// extracted by mini-css-extract-plugin
export default {"cards_outer":"cards_cards_outer__dv8pe","cards_inner":"cards_cards_inner__AX+fR","cards_title":"cards_cards_title__OeHfC","card":"cards_card__TFDwv","loading":"cards_loading__gp+vg"};